import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import ProductCodeFilterInput from "../../sales/common/ProductCodeFilterInput";

const saleReturnCardFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ProductCodeFilterInput
      alwaysOn
      source="goods_code"
      variant="outlined"
      label="mine.label.goods_code"
    />,
    <ReferenceInput
      alwaysOn
      source="customer_id"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        optionText="name"
        resettable
        variant="outlined"
        label="mine.label.customer"
        filterToQuery={(searchText) => ({ all: searchText })}
      />
    </ReferenceInput>,
    <ReferenceInput alwaysOn source="quality_id" reference="qualities">
      <AutocompleteInput
        label="mine.label.quality"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
    <ReferenceInput alwaysOn source="size_id" reference="sizes">
      <AutocompleteInput
        label="mine.label.size"
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText="name"
        filterToQuery={(searchText) => ({
          name: searchText,
        })}
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.depo"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default saleReturnCardFilterList;
